import React from "react"
class Slider extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value || ''
		}

		this.onChange = this.onChange.bind(this);
		
	}

	render() {
		if(this.props.read_only === true) {
			return (
				<input disabled ref="slider" type="range" min={this.props.min || 0} max={this.props.max || 100} step={this.props.step || 1} name={this.props.name} value={this.state.value} onChange={this.onChange} />
			)
		} else {
			return (
				<input ref="slider" type="range" min={this.props.min || 0} max={this.props.max || 100} step={this.props.step || 1} name={this.props.name} value={this.state.value} onChange={this.onChange} />
			);
		}
	}

	onChange(event) {
		this.setState({value: event.target.value}, () => {
			if (typeof this.props.onChange === 'function') {
				this.props.onChange({
					target: {
						name: this.props.name,
						value: this.state.value
					}
				})
			}
		});
	}
}
export default Slider